import { FaLock } from 'react-icons/fa';

const TG_SUPPORT_LINK = 'https://t.me/skinforge_support'; // Измени на свой актуальный support

const BannedPage = () => (
	<div style={{
		minHeight: '100vh',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		background: 'linear-gradient(135deg, #18181b 60%, #2563eb 100%)',
		color: '#fff',
		padding: 24
	}}>
		<div style={{
			background: 'rgba(37,99,235,0.12)',
			borderRadius: 32,
			padding: 36,
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
			maxWidth: 400,
			width: '100%'
		}}>
			<FaLock size={64} color="#2563eb" style={{ marginBottom: 24 }} />
			<h1 style={{ fontSize: 30, fontWeight: 800, margin: 0, marginBottom: 18, textAlign: 'center' }}>
				Ваш аккаунт заблокирован
			</h1>
			<p style={{ fontSize: 18, color: '#e5e7eb', marginBottom: 32, textAlign: 'center' }}>
				Ваш аккаунт заблокирован из-за нарушений пользовательского соглашения.<br />
				Если вы считаете, что это ошибка — обратитесь в нашу поддержку.
			</p>
			{/* <a
				href={TG_SUPPORT_LINK}
				target="_blank"
				rel="noopener noreferrer"
				style={{
					display: 'inline-block',
					background: '#2563eb',
					color: '#fff',
					padding: '14px 32px',
					borderRadius: 12,
					fontSize: 18,
					fontWeight: 700,
					textDecoration: 'none',
					boxShadow: '0 2px 8px rgba(37,99,235,0.18)',
					transition: 'background 0.2s',
				}}
			>
				Написать в поддержку
			</a> */}
		</div>
	</div>
);

export default BannedPage; 